export default class GlobalUtility {
    static ensureHttps = url => {
        if (!url) return '';

        if (!url.match(/^(https?|frn):\/\//i)) {
            url = 'https://' + url;
        }

        return url;
    }

    static safeOpenUrl = url => {
        const safeUrl = this.ensureHttps(url)

        if (safeUrl) {
            window.open(safeUrl, '_blank', 'noopener,noreferrer');
        }
    }

    static redirectExternalUrl = (url, props) => {
        let finalUrl = this.ensureHttps(url)
        if (props.location.search) {
            finalUrl += props.location.search;
        }
        window.location.href = finalUrl;
    }

    static redirectInternalUrl = (url, props) => {
        let finalUrl = url;
        if (finalUrl[0] !== '/') {
            finalUrl = '/' + finalUrl;
        }
        if (props.location.search) {
            finalUrl += props.location.search;
        }
        props.history.push(finalUrl);
    }

    static verifyLastPath = (pathToVerify) => {
        const path = window.location.pathname;
        const lastPath = path.split('/').pop();
        return lastPath.includes(pathToVerify);
    }

    static isFlagOn = (generalStore, flagName) => {
        return generalStore?.domainSettings?.[flagName];
    }
}